import * as React from 'react';
import * as vars from '../../consts/variables';
import loadable from '@loadable/component';

const CustomSelect = loadable(() => import('../../components/CustomSelect/CustomSelect'));

interface IOptionProp {
    option: IValue;
    onSelect(IValue): void;
}

class OptionComponent extends React.Component<IOptionProp, {}> {
    handleClick = () => this.props.onSelect(this.props.option);

    render() {
        return (
            <div onClick={this.handleClick} className="country-code-select">
                {this.props.option.icon && (
                    // empty "alt" to now show broken icon if image is not found
                    <img
                        className="country-flag"
                        src={this.props.option.icon}
                        height={15}
                        width={15}
                        alt=""
                    />
                )}
                <span>{this.props.option.label}</span>
            </div>
        );
    }
}

function ValueComponent(props) {
    return (
        <div className="country-code-select">
            {props.value.icon && (
                <img
                    className="country-flag"
                    src={props.value.icon}
                    height={15}
                    width={15}
                    alt=""
                />
            )}
            <span>{props.value.label}</span>
        </div>
    );
}

interface IValue {
    value: string;
    label?: string;
    icon?: string;
}

interface IProps {
    options: IValue[];
    value: IValue;
    onChange(value: IValue);
    placeholder: string;
    isError: boolean;
    testSelectorName?: string;
}

export function CountryCodeSelect(props: IProps) {
    const selectStyle: any = {
        border: props.isError ? `1px solid ${vars.pink}` : `1px solid ${vars.gray}`,
        color: props.value && props.value.value === '-1' ? vars.mediumBlack : vars.black,
    };
    return (
        <CustomSelect
            value={props.value}
            valueComponent={ValueComponent}
            options={props.options}
            optionComponent={OptionComponent}
            onChange={props.onChange}
            clearable={false}
            searchable={false}
            placeholder={props.placeholder}
            style={selectStyle}
            testSelectorName={props.testSelectorName}
        />
    );
}
